import React from "react";

import { AliasesCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function aliases({ width, onResize }: Column.Options) {
	return base(ColumnId.Aliases, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default aliases;
